// @flow

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import * as StringUtil from 'app/common/lib/StringUtil';
import i18n from 'app/common/lib/i18n';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyButton from 'app/common/react/ui/deprecated/LegacyButton';

type Props = {
  firstName: string,
  onClearModal: () => void,
};

class BlockConfirmation extends Component<Props> {
  componentDidMount() {
    const button = ReactDOM.findDOMNode(this.button);
    if (button instanceof HTMLElement) {
      button.focus();
    }
  }

  saveButtonRef = (ref: ?LegacyButton) => {
    this.button = ref;
  };

  button: ?LegacyButton;

  render() {
    const { firstName, onClearModal } = this.props;
    return (
      <form className="standardForm" method="post">
        <div className="body">
          <p>
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: StringUtil.safeFormat(
                  i18n._("You've blocked <strong>{{ name }}</strong>"),
                  { name: firstName },
                ),
              }}
            />
          </p>
        </div>
        <div className="formFooter">
          <div className="formFooterButtons">
            <LegacyButton
              onClick={onClearModal}
              ref={this.saveButtonRef}
              text={i18n._('OK')}
              type="primary"
            />
          </div>
        </div>
      </form>
    );
  }
}

export default BlockConfirmation;
